/**
 * Monthly "days per week" pricing packs (frequency MONTH, frequencyType DAYS_PER_WEEK).
 *
 * The student picks N fixed weekdays (frequencyValue) that repeat every week of every
 * booked month. Booking reuses the weekly pack's weekday picker; billing stays monthly.
 * With "All days" (all: true) the pack books every class day, like any all-days monthly pack.
 */
export const isMonthDaysPerWeekPack = (pricingPack: any): boolean =>
  pricingPack?.frequency === "MONTH" &&
  pricingPack?.frequencyType === "DAYS_PER_WEEK" &&
  pricingPack?.all === false;
